<template>
  <!-- 对比分析 -->
  <el-row class="contrastive-analysis flex-grow-1" type="flex" :gutter="12">
    <el-col :span="5" class="tree-container d-flex flex-column">
      <project-tree-selector class="flex-grow-1" @select-node="selectNodeListener" @node-list="nodeListChangeListener">
      </project-tree-selector>
    </el-col>
    <!-- 右側 -->
    <el-col :span="19" class="d-flex flex-column align-items-stretch">
      <div class="breadcrumbs-contain d-flex align-items-center section-container" :class="{'dark':skinType}">
        <SectionTitle title="对比分析"></SectionTitle>
        <breadcrumbs :selectNode="selectNode" :nodeList="nodeList"></breadcrumbs>
      </div>
      <!-- 條件查詢 -->
      <div class="selector-container section-container" :class="{'dark':skinType}">
        <el-form :inline="true" class="demo-form-inline" style="text-align: left" size="small">
          <period-date-selector :isDateSelector="
            false
            " @startEndDate="startEndDateListener"></period-date-selector>
          <el-form-item label="">
            <el-radio-group v-model="compareDateType" size="small" :class="{'dark':skinType}">
              <el-radio-button v-for="item in options" :key="item.value" :label="item.value">{{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="exportTable">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table size="small" class="energy-table none-height flex-grow-1 d-flex flex-column" :data="tableData" stripe
        height="0" style="width: 100%" ref="table" :class="{'dark':skinType}"
        :row-class-name="(...nu)=>{return skinType?'dark text-white':''}">
        <el-table-column prop="PointName" label="监测点" min-width="120"> </el-table-column>
        <el-table-column label="基准日期">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.BaseDate.split(" ")[0]
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="BasePowerConsumption" label="基准电量(kWh)">
        </el-table-column>
        <el-table-column prop="ContrastivePowerConsumption" label="对比电量(kWh)">
        </el-table-column>
        <el-table-column prop="Rise" label="增电量(kWh)"> </el-table-column>
        <el-table-column label="增长率(%)">
          <template slot-scope="scope">
            <span>{{
              scope.row.RateOfRise ? scope.row.RateOfRise.toFixed(2) : "--"
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="d-flex section-container" style="padding: 1rem" :class="{'dark':skinType}">
        <el-pagination v-if="pageInfo.total" :page-size="pageInfo.size" :class="{'text-white':skinType}" style="margin-left: auto" background
          layout="total, prev, pager, next" :total="pageInfo.total" :current-page.sync="pageIndex">
        </el-pagination>
      </div>
    </el-col>
  </el-row>
</template>
<script>
  import ProjectTreeSelector from '@/components/utils/project-tree-selector.vue';
  import { contrastiveAnalysis } from '@/api/statistic/statistic';
  import PeriodDateSelector from '@/components/energy-analysis/components/period-date-selector.vue';
  import Breadcrumbs from '@/components/utils/breadcrumbs.vue';
  import { exportExcel } from '@/utils/utils';
  import equipDateTypeMixin from '@/components/energy-analysis/mixin/mixin';
  import SectionTitle from '@/components/utils/section-title.vue';

  export default {
    name: 'contrastive-analysis',
    components: {
      ProjectTreeSelector,
      PeriodDateSelector,
      Breadcrumbs,
      SectionTitle,
    },
    mixins: [equipDateTypeMixin],
    data() {
      return {
        pageIndex: 1,
        startEndDate: null,
        compareDateType: 1,
        pageInfo: {
          index: 1,
          size: 40,
          total: 0,
        },
        selectNode: null,
        tableData: [],
        options: [
          {
            label: '上日',
            value: 1,
          },
          {
            label: '上周',
            value: 2,
          },
          {
            label: '上月',
            value: 3,
          },
          {
            label: '上年',
            value: 4,
          },
        ],
        nodeList: [],
      };
    },
    watch: {
      pageIndex() {
        this.requestConstrativeList();
      },
      selectNode() {
        if (this.pageIndex !== 1) {
          this.pageIndex = 1;
          return;
        }
        // if (this.isDateSelectorChange(newVal, oldVal)) {
        //   return;
        // }
        this.requestConstrativeList();
      },
      startEndDate() {
        if (this.pageIndex !== 1) {
          this.pageIndex = 1;
          return;
        }
        this.requestConstrativeList();
      },
      compareDateType() {
        if (this.pageIndex !== 1) {
          this.pageIndex = 1;
          return;
        }
        this.requestConstrativeList();
      },
    },
    computed: {
      skinType() {
        return this.$store.getters.skinType;
      },
    },
    methods: {
      nodeListChangeListener(list) {
        this.nodeList = list;
      },
      currentChangeListener(no) {
        this.pageIndex = no;
      },
      startEndDateListener(datePeriod) {
        this.startEndDate = datePeriod;
      },
      requestConstrativeList() {
        if (this.startEndDate === null) {
          return;
        }
        if (this.selectNode === null) {
          return;
        }
        // if (!this.isDateOfEquip(this.selectNode.oType, this.startEndDate.isDateSelector)) {
        //   return;
        // }
        contrastiveAnalysis({
          oType: this.selectNode.oType,
          oIDstr: this.selectNode.IdStr,
          cType: this.compareDateType,
          BeginDate: this.startEndDate.start,
          EndDate: this.startEndDate.end,
          page: this.pageIndex,
          rows: this.pageInfo.size,
        })
          .then((res) => {
            if (res !== null && res.list) {
              this.tableData = res.list;
              this.pageInfo.total = res.total;
              return;
            } else if (res.length) {
              this.tableData = res;
              return;
            }
            this.tableData = res || [];
            this.pageInfo.total = 0;
          })
          .catch(() => {
            this.tableData = [];
            this.pageInfo.total = 0;
          });
      },
      selectNodeListener(node) {
        this.pageIndex = 1;
        this.selectNode = node;
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      onSubmit() {
        this.requestConstrativeList();
      },
      exportTable() {
        exportExcel(this.$refs.table.$el);
      },
    },
  };
</script>
<style scoped>
  .energy-table.el-table .warning-row {
    background: oldlace;
  }

  .energy-table.el-table .success-row {
    background: #f0f9eb;
  }

  .breadcrumbs-contain {
    padding: 1rem;
    margin-bottom: 1rem;
  }
</style>